import "bootstrap/dist/css/bootstrap.min.css";
import { lazy, Suspense } from "react";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Footer from "./components/Footer/Footer";
import Loader from "./components/Loader/Loader";
import NavBar from "./components/Navbar/Navbar";
const Home = lazy(() => import("./pages/Home"));
const Shop = lazy(() => import("./pages/Shop"));
const Cart = lazy(() => import("./pages/Cart"));
const Product = lazy(() => import("./pages/Product"));
const Auth = lazy(() => import("./pages/Auth"));
const ProfilePage = lazy(() => import("./components/Profile/ProfilePage"));
const Careers = lazy(()=>import("./components/Footer/Aboutus/Career/Careers"))
const OurStores = lazy(()=>import("./components/Footer/Aboutus/OurStores/OurStores"))
const  OurCares = lazy(()=>import("./components/Footer/Aboutus/OurCares/OurCares"))
const TermsCondition = lazy(()=>import("./components/Footer/Aboutus/TermsCondition/TermsCondition"))
const PrivacyPolicy = lazy(()=>import("./components/Footer/Aboutus/PrivacyPolicy/PrivacyPolicy"))
const HelpCenter = lazy(()=>import("./components/Footer/CustomerCare/HelpCenter/HelpCenter"))
const HowtoBuy = lazy(()=>import("./components/Footer/CustomerCare/HowtoBuy/HowtoBuy"))
const  ReturnRefunds = lazy(()=>import("./components/Footer/CustomerCare/ReturnRefunds/ReturnRefunds"))
const TrackOrder = lazy(()=>import("./components/Footer/CustomerCare/TrackOrder/TrackOrder"))
const BulkPurchasing = lazy(()=>import("./components/Footer/CustomerCare/BulkPurchasing/BulkPurchasing"))







function App() {

  
  return (
    <Suspense fallback={<Loader />}>
      <Router>
        <ToastContainer
          position="top-right"
          autoClose={1000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
        <NavBar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/shop/:id" element={<Product />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/auth/:authType" element={<Auth />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/careers" element={<Careers/>} />
          <Route path="/ourstores" element={<OurStores/>} />
          <Route path="/ourcares" element={<OurCares/>} />
          <Route path="/terms-conditions" element={<TermsCondition/>} />
          <Route path="/privacy-policy" element={<PrivacyPolicy/>} />
          <Route path="/helpcenter" element={<HelpCenter/>} />
          <Route path="/howtobuy" element={<HowtoBuy/>} />
          <Route path="/trackorder" element={<TrackOrder/>} />
          <Route path="/businesspurchasing" element={<BulkPurchasing/>} />
          <Route path="/returnrefunds" element={<ReturnRefunds/>} />
        </Routes>
        <Footer />
      </Router>
    </Suspense>
  );
}

export default App;
